import { Color } from "@swimlane/ngx-charts";

export interface ChartConfig {
    showXAxis: boolean;
    showYAxis: boolean;
    gradient: boolean;
    showLegend: boolean;
    showXAxisLabel: boolean;
    xAxisLabel: string;
    showYAxisLabel: boolean;
    yAxisLabel: string;
    colorScheme: Color;
}

export interface ChartValue {
    name: string;
    value: number;
}

export interface MultiChartValue {
  name: string;
  series: ChartValue[];
}

export const medicineReportData: MultiChartValue [] =[
  {
    name: 'Aspirin',
    series: [
      {
        "name": "January",
        "value": 100
      },
      {
        "name": "February",
        "value": 200
      },
      {
        "name": "March",
        "value": 300
      },
      {
        "name": "April",
        "value": 250
      },
      {
        "name": "May",
        "value": 150
      }
    ]
  },
  {
    name: 'Panado',
    series: [
      {
        "name": "January",
        "value": 640
      },
      {
        "name": "February",
        "value": 500
      },
      {
        "name": "March",
        "value": 600
      },
      {
        "name": "April",
        "value": 720
      },
      {
        "name": "May",
        "value": 7
      }
    ]
  },
  {
    name: 'Paracetamol',
    series: [
      {
        "name": "January",
        "value": 102
      },
      {
        "name": "February",
        "value": 204
      },
      {
        "name": "March",
        "value": 512
      },
      {
        "name": "April",
        "value": 128
      },
      {
        "name": "May",
        "value": 256
      }
    ]
  },
  {
    name: 'Ibuprofen',
    series: [
      {
        "name": "January",
        "value": 120
      },
      {
        "name": "February",
        "value": 596
      },
      {
        "name": "March",
        "value": 90
      },
      {
        "name": "April",
        "value": 390
      },
      {
        "name": "May",
        "value": 631
      }
    ]
  }
];


export interface DashboardPayload {
    start_date: string;
    end_date: string;
    type: string;
    doctor_id: number | undefined;
    company_id: number | undefined;
}


export interface DeliveryPayload {
  start_date: string;
  end_date: string;
  type: string;
  company_id: number | null | undefined;
}
export interface MedicineReportPayload extends DashboardPayload {
  format: string | undefined;
  doctor_id: number | undefined;
  company_id: number | undefined;
}

export interface DashboardData {
  orders: ChartValue[], 
  batches: ChartValue[],
  medicine: MultiChartValue[],
}

export interface Criteria{
  type: string;
  value: string;
}

export const criterias: Criteria []  = [
  {
    type: "Monthly",
    value: "monthly"
  },
  {
    type: "Weekly",
    value: "weekly"
  },
  {
    type: "Daily",
    value: "daily"
  }
]

export const medicineColorsDomain: string []
 = [
  '#000000',
  '#00FF00',
  '#0000FF',
  '#FF0000',
  '#01FFFE',
  '#FFA6FE',
  '#FFDB66',
  '#006401',
  '#010067',
  '#95003A',
  '#007DB5',
  '#FF00F6',
  '#FFEEE8',
  '#774D00',
  '#90FB92',
  '#0076FF',
  '#D5FF00',
  '#FF937E',
  '#6A826C',
  '#FF029D',
  '#FE8900',
  '#7A4782',
  '#7E2DD2',
  '#85A900',
  '#FF0056',
  '#A42400',
  '#00AE7E',
  '#683D3B',
  '#BDC6FF',
  '#263400',
  '#BDD393',
  '#00B917',
  '#9E008E',
  '#001544',
  '#C28C9F',
  '#FF74A3',
  '#01D0FF',
  '#004754',
  '#E56FFE',
  '#788231',
  '#0E4CA1',
  '#91D0CB',
  '#BE9970',
  '#968AE8',
  '#BB8800',
  '#43002C',
  '#DEFF74',
  '#00FFC6',
  '#FFE502',
  '#620E00',
  '#008F9C',
  '#98FF52',
  '#7544B1',
  '#B500FF',
  '#00FF78',
  '#FF6E41',
  '#005F39',
  '#6B6882',
  '#5FAD4E',
  '#A75740',
  '#A5FFD2',
  '#FFB167',
  '#009BFF',
  '#E85EBE',
 ];